import bg from '../assets/img/Line.png'
import Navbar from './NavBar.js'
import Roll from 'react-reveal/Roll';

function HeroSection() {
    return (
        <div className="sec1">
          <Navbar />
          <Roll right>
          <div className="HeroSec">
            <h2>Nooras Fatima</h2>
            <img src={bg} alt="line" />
            <p>Programmer | Designer | Learner</p>
            </div>
            </Roll>
          </div>
        );
    }
    
export default HeroSection;